/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { PaymentInvoice } from "../types/SubTransactionTypes";


type Response = {
  payload: PaymentInvoice[];
  pagination_data: null;
};

export function usePaymentInvoiceByProject(project_id:number) {

    const params={
        project_id: project_id
    }

    let url = "/project/get_payment_invoice_by_project_id" ;
    const api = useApi();
    const [data, setData] = useState<PaymentInvoice[]>([]);
    const [isLoading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    const fetchData = () => {
        setLoading(true);

        api
        .get(url,{params})
        .then((res: SuccessFetch<Response>) => {
            const data = res.data.payload ?? [];
            setData(data);
        })
        .catch(() => setData([]))
        .finally(() => setLoading(false));
    };

    const refetch = () => fetchData();

    useEffect(() => {
        if (hasFetched.current) return; // tidak fetch ulang
        hasFetched.current = true;
        fetchData();

        return () => {
            setData([]);
        };
        // eslint-disable-next-line
    }, []);

    return {
        data,
        isLoading,
        refetch,
    };
}